<template>
    <el-dialog
            :title="deleteTextConfig.title"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            @close="reset"
            width="700px">

        <el-form :model="form" :rules="rules" ref="form" label-width="30px">
            <el-form-item label="">
                <span><i class="el-icon-warning-outline" style="font-size: 25px;color:orange"></i>{{deleteTextConfig.message.signMix(name)}}</span>
            </el-form-item>
            <el-form-item label="">
                <span>{{deleteTextConfig.tip}}</span>
            </el-form-item>
            <el-form-item label="" prop="name">
                <el-input v-model="form.name" :placeholder="deleteTextConfig.examName" clearable></el-input>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ deleteTextConfig.cancel }}</el-button>
            <el-button type="primary" @click="deleteExam">{{ deleteTextConfig.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {deleteExam} from "@/api/arrangement";
export default {
    computed: {
        deleteTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.paperConfig.table.button.delete
        },
    },
    data() {
        return {
            dialogVisible: false,
            examId: null,
            name: null,
            form: {
                name: null,
            },
            rules: {
                name: [
                    {required: true, message: '竞赛计划名称不能为空', trigger: 'blur'},
                    {
                        validator: function (rule, value, callback) {
                            if (value && value != this.name) {
                                callback(new Error("校验不通过"))
                            } else {
                                callback();
                            }
                        }.bind(this),
                        trigger: 'blur',
                    },
                ],

            }
        }
    },

    methods: {
        open(examId, name) {
            this.dialogVisible = true
            this.examId = examId
            this.name = name
        },
        reset(){
            this.form.name=''
        },
        deleteExam() {
            this.$refs.form.validate(vaild => {
                if (vaild) {
                    deleteExam(this.examId).then(res => {
                        if (res.status === 200) {
                            this.$message.success('删除竞赛计划成功')
                            this.dialogVisible = false
                            this.$emit('success')
                        }
                    })
                }
            })
        },
    }
}
</script>

<style scoped>

</style>
